module.exports = __webpack_public_path__ + "img/5.3fcf0d2b.png";